import { createSlice, nanoid } from "@reduxjs/toolkit";
import { sub } from 'date-fns';


// const initialState = [
//     {
//         id: '1',
//         name: 'Learning Redux Toolkit',
//         email: "I've heard good things.",
//         phone: '1234567890',
//         info: "",
//         date: sub(new Date(), { minutes: 10 }).toISOString(),

//     },
//     {
//         id: '2',
//         name: 'Learning Redux Toolkit',
//         email: "I've heard good things.",
//         phone: '1234567890',
//         info: "",
//         date: sub(new Date(), { minutes: 10 }).toISOString(),

//     }
// ]

const users = createSlice({
    name: 'users',
    initialState:{
        users: null
    },
    // initialState,
    reducers: {
        registerUser: {
            reducer(state, action) {
                // state.push(action.payload)
                state.users = action.payload;

            },
            prepare(name: string, email: string, phone: string, advert:string):any {
                return {
                    payload: {
                        id: nanoid(),
                        name,
                        email,
                        phone,
                        advert,
                        date: new Date().toISOString(),
                    
                    }
                }
            }
        },
    }
})

export const selectAllUsers = (state: any) => state.users;

export const { registerUser } = users.actions

export default users.reducer